const API = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '';
const samples: number[] = [];
/** A refusal from the API: the status, the server's message, and the whole body (for example a 409's `reason` and `overrideAllowed`). */
export class ApiError extends Error {
  constructor(public status: number, message: string, public body: Record<string, unknown> = {}) { super(message); }
}

export function noteServerTime(serverTime: number, t0: number, t1: number) {
  samples.push(serverTime - (t0 + (t1 - t0) / 2)); if (samples.length > 7) samples.shift();
}
export function clockOffset(): number { if (!samples.length) return 0; const s = [...samples].sort((a, b) => a - b); return s[Math.floor(s.length / 2)]; }
export const serverNow = () => Date.now() + clockOffset();
/** The full address of an API path, for the rare call that cannot go through api() (the goodbye in lib/presence). */
export const apiUrl = (path: string): string => API + path;

export async function api<T>(path: string, init: RequestInit & { token?: string } = {}): Promise<T> {
  const { token, headers, ...rest } = init;
  const t0 = Date.now();
  const res = await fetch(apiUrl(path), { ...rest, headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}), ...(headers as Record<string, string> | undefined) } });
  const t1 = Date.now();
  const body = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (typeof body.serverTime === 'number') noteServerTime(body.serverTime, t0, t1);
  if (!res.ok) throw new ApiError(res.status, typeof body.error === 'string' ? body.error : 'something went wrong', body);
  return body as T;
}
